import MoneyDisplay from 'components/util/MoneyDisplay';
import { GroupedTransfers } from './bankTransferGroupBy';

type Props = {
    /** What the group is grouped ON — "Date" or "Uploaded at" — so the heading reads unambiguously. */
    caption: string;
    title: string;
    group: GroupedTransfers;
};

/**
 * The strip above a group of rows: the day the group covers, and its amounts per currency.
 *
 * The figures cover the rows the list has LOADED, not the whole filtered set — see
 * {@link GroupedTransfers.currencyTotals}.
 */
export function BankTransferGroupRibbon({ caption, title, group }: Props): JSX.Element {
    return (
        <div className="bg-grey-50 flex w-full items-baseline gap-4 px-4 py-[9px]">
            <div className="flex min-w-0 flex-1 items-baseline gap-2">
                <span className="text-caption text-fg-secondary font-semibold whitespace-nowrap">{caption}</span>
                <span className="text-subtitle2 font-semibold whitespace-nowrap">{title}</span>
            </div>
            <div className="flex flex-none gap-2">
                {[...group.currencyTotals].map(([currency, amount]) => (
                    <span key={currency} className="flex items-baseline gap-1 whitespace-nowrap">
                        <span className="text-caption text-fg-secondary font-semibold">{currency}:</span>
                        <span className="text-subtitle2 font-semibold">
                            <MoneyDisplay amount={amount} />
                        </span>
                    </span>
                ))}
            </div>
        </div>
    );
}
